<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M20 4.9a1 1 0 0 1 1.6 0q.8.7 0 1.6L10 19.1a1.2 1.2 0 0 1-1.7 0l-5.9-6.3q-.6-.9 0-1.7.9-.6 1.6 0l5 5.5z"
    />
  </svg>
</template>
